import React, { useContext, useState } from 'react'
import SoapNotesForm from '../soap-notes-form/SoapNotesForm'
import SoapNotesService from '../../../../../../services/api/soapnotes.service'
import { store } from '../../../../../../context/StateProvider'
import DimLoader from '../../../../../templates/components/DimLoader'
import APIResponse from '../../../../../templates/components/APIResponse'
const SoapNotesAdd = (props) => {
    // context state and dispatch 
    const globalStateAndDispatch = useContext(store)
    const state = globalStateAndDispatch.state
    const [apiResponse, setApiResponse] = useState()
    const [isSubmitted, setIsSubmitted] = useState(false)
    const onSuccess = (message) => {
        if (props.refresh) {
            props.refresh()
        }
        if (props.onClose) {
            props.onClose()
        }
        if (props.exitHandler) {
            props.exitHandler()
        }
    }

    const submitHandler = (data) => {
        setIsSubmitted(true)
        const reqObj = { ...data, practiceLocationId: state.practiceLocationId }
        if (props.appointmentId) {
            reqObj.appointmentId = props.appointmentId
        }
        SoapNotesService.addSoapNotes(props.patientId, reqObj)
            .then(res => {
                setApiResponse(res)
            })
            .catch(error => {
                setApiResponse(error)
            })
            .finally(() => {
                setIsSubmitted(false)
            })
    }
    return (
        <>
            {isSubmitted ? <DimLoader loadMessage="Processing..." /> : null}
            <SoapNotesForm patientId={props.patientId} onClose={() => props.onClose()} submitLabel="Add" submitHandler={submitHandler} />
            <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true} />
        </>

    )
}

export default SoapNotesAdd